var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from '../Tooltip';
import Help from '../Icons/dist/components/Help';
import styles from './Input.scss';

var InputHelpSuffix = function (_React$Component) {
  _inherits(InputHelpSuffix, _React$Component);

  function InputHelpSuffix() {
    _classCallCheck(this, InputHelpSuffix);

    return _possibleConstructorReturn(this, (InputHelpSuffix.__proto__ || Object.getPrototypeOf(InputHelpSuffix)).apply(this, arguments));
  }

  _createClass(InputHelpSuffix, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        Tooltip,
        {
          dataHook: 'input-tooltip',
          disabled: this.props.helpMessage.length === 0,
          maxWidth: '250px',
          placement: 'right',
          moveBy: { x: 2, y: 0 },
          alignment: 'center',
          hideDelay: 100,
          content: this.props.helpMessage,
          overlay: ''
        },
        React.createElement(
          'div',
          { className: styles.help },
          React.createElement(Help, { height: '20', width: '20' })
        )
      );
    }
  }]);

  return InputHelpSuffix;
}(React.Component);

InputHelpSuffix.propTypes = {
  theme: PropTypes.oneOf(['normal', 'paneltitle', 'material', 'amaterial']),
  helpMessage: PropTypes.string.isRequired,
  help: PropTypes.bool
};

export default InputHelpSuffix;
//# sourceMappingURL=InputHelpSuffix.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Input/InputHelpSuffix.js